<template>
  <div class="card card-1 p-10-px  single-material">
     <b-row>
       <b-col cols="4">{{ material.value }}</b-col>
       <b-col cols="3">{{ material.TypeOfMaterial.materialType }}</b-col>
       <b-col cols="3"><b-badge variant="outline-info">{{ material.Unit.name }}</b-badge></b-col>
       <b-col cols="2">
          
          <b-form-checkbox value="active" unchecked-value="inactive" class="float-right" v-model="checked" name="check-button" switch @input="updateActiveState"></b-form-checkbox>

          <a href="" class="text-danger m-r-10"><i class="fa fa-trash-o" aria-hidden="true" @click.prevent="initiateDelete"></i></a>
          <a href="" class="text-primary" @click.prevent="initiateUpdate"><i class="fa fa-pencil-square-o" aria-hidden="true"></i></a>

       </b-col>
     </b-row>
  </div>
</template>

<script>
import EventBus from '../../../../EventBus';

import MaterialStockService from '../../../../services/material-stock.service';

  export default {
     props: {
       material: {
         type: Object,
         default: () => ({})
       }
     },
     data() {
      return {
        checked: this.material.active
      }
    },
    methods: {
      async updateActiveState(){
         try{
            const updateStatus = await MaterialStockService.updateActiveState(
              this.material.id,
              {active: this.checked}
            ) 

            this.$toasted.show(updateStatus.data.message, {
                type: "success",
                action: {
                  text: "Close",
                  class: "toastBtnTxt",
                  onClick: (e, toastObject) => {
                    toastObject.goAway(0);
                  },
                },
                duration: 5000,
              });

         }catch(errors){
           console.log(errors)
         }
      },
      initiateUpdate(){
         EventBus.$emit('stocks.update-material-item', this.material)
      },
      initiateDelete(){
        this.$dialog
          .confirm('Please confirm to continue')
          .then((dialog) => {
              this.deleteMaterial();
          })
          .catch((errors) => {

            console.log('Clicked on cancel', errors);
          });
      },
      async deleteMaterial(){
        try{
           const deleteStatus = await MaterialStockService.deleteMaterialItem(this.material.id);
          
            this.$toasted.show(deleteStatus.data.message, {
                type: "success",
                action: {
                  text: "Close",
                  class: "toastBtnTxt",
                  onClick: (e, toastObject) => {
                    toastObject.goAway(0);
                  },
                },
                duration: 5000,
              });

            EventBus.$emit("stocks.deleted-material-stock", this.material.id)
        }catch(errors){

             this.$toasted.show(errors.response.data.message, {
                type: "success",
                action: {
                  text: "Close",
                  class: "toastBtnTxt",
                  onClick: (e, toastObject) => {
                    toastObject.goAway(0);
                  },
                },
                duration: 5000,
              });
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .single-material{
    font-size: 13px;
    margin-bottom: 2px;
  }
</style>